export default __webpack_public_path__ + "static/media/cof_init.a90e9909.png";